import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-brand-loader',
  templateUrl: './brand-loader.component.html',
  styleUrls: ['./brand-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLoaderComponent {
  @Input() public label = 'Cargando...';
}
